// src/components/Header.js
import React, { useState } from "react";
import {
  Button,
  Avatar,
  Dropdown,
  Tooltip,
  Modal,
  Form,
  Input,
  message,
} from "antd";
import {
  MenuOutlined,
  FullscreenOutlined,
  FullscreenExitOutlined,
  SettingOutlined,
  UserOutlined,
  ContactsOutlined,
  CarOutlined,
  ClockCircleOutlined,
  DashboardOutlined,
  NodeIndexOutlined,
  AuditOutlined,
  FileTextOutlined,
  ApartmentOutlined,
  BankOutlined,
  BarChartOutlined,
  CarryOutOutlined,
  ControlOutlined,
  FileDoneOutlined,
  IdcardOutlined,
  LinkOutlined,
  MedicineBoxOutlined,
  ProfileOutlined,
  SafetyCertificateOutlined,
  SolutionOutlined,
  UnorderedListOutlined,
} from "@ant-design/icons";
import PropTypes from "prop-types";
import { useNavigate, useLocation } from "react-router-dom";
// Eliminado: import { useSocket } from "../SocketContext";
import { useUser } from "../UserContext";
import api from "../../src/axiosConfig";
import "../styles/modern-layout.css";
import ConnectionStatus from "./ConnectionStatus";

const HeaderComponent = ({ toggleSidebar }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isFullscreen, setIsFullscreen] = useState(false);
  // Eliminado: const { socket, socketConnected } = useSocket();
  const { user, setUser } = useUser();
  // Eliminamos estas líneas ya que ahora las maneja ConnectionStatus
  // const { isOnline, latency } = useConnection();
  // const { connectionState } = useWebSocketStatus();

  const [changePasswordModalVisible, setChangePasswordModalVisible] =
    useState(false);
  const [form] = Form.useForm();

  const handlePasswordChange = async (values) => {
    try {
      const response = await api.post(
        `/usuarios/${user.id}/cambiar-contrasena`,
        {
          contrasenaActual: values.currentPassword,
          nuevaContrasena: values.newPassword,
        }
      );
      message.success(response.data.message);
      setChangePasswordModalVisible(false);
      form.resetFields();
    } catch (error) {
      message.error(
        error.response?.data?.message || "Error al cambiar contraseña"
      );
    }
  };

  const handleModalClose = () => {
    form.resetFields();
    setChangePasswordModalVisible(false);
  };

  const handleFullscreen = () => {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen().catch((e) => console.log(e));
      setIsFullscreen(true);
    } else {
      document.exitFullscreen();
      setIsFullscreen(false);
    }
  };

  const handleLogout = () => {
    setUser(null);
    localStorage.removeItem("user");
    navigate("/login");
  };
  const userInitial = user?.nombre?.charAt(0).toUpperCase() || "U";

  const routeTitles = [
    { path: "/UserList", title: "Lista de Usuarios", icon: <UnorderedListOutlined /> },
    {
      path: "/UserCards",
      title: "Tarjetas de Usuarios",
      icon: <IdcardOutlined />,
    },
    { path: "/Patients", title: "Pacientes", icon: <MedicineBoxOutlined /> },
    {
      path: "/Authorizations",
      title: "Autorizaciones",
      icon: <FileDoneOutlined />,
    },
    { path: "/Clients", title: "Clientes", icon: <ContactsOutlined /> },
    { path: "/Drivers", title: "Conductores", icon: <SolutionOutlined /> },
    { path: "/Vehicles", title: "Vehículos", icon: <CarOutlined /> },
    {
      path: "/VehiculoConductores",
      title: "Asignaciones",
      icon: <LinkOutlined />,
    },
    {
      path: "/TimeCheck",
      title: "Verificación de Hora",
      icon: <ClockCircleOutlined />,
    },
    { path: "/Institutions", title: "Instituciones", icon: <BankOutlined /> },
    {
      path: "/CenterControl",
      title: "Centro de Control",
      icon: <ControlOutlined />,
    },
    {
      path: "/Coordinacion",
      title: "Coordinación",
      icon: <NodeIndexOutlined />,
    },
    {
      path: "/ControlServicios",
      title: "Control de Servicios",
      icon: <AuditOutlined />,
    },
    {
      path: "/preoperations",
      title: "Pre Operacionales",
      icon: <CarryOutOutlined />,
    },
    {
      path: "/roles",
      title: "Roles y Permisos",
      icon: <SafetyCertificateOutlined />,
    },
    { path: "/Dashboard", title: "Dashboard", icon: <DashboardOutlined /> },
    {
      path: "/Transportadoras",
      title: "Transportadoras",
      icon: <ApartmentOutlined />,
    },
    {
      path: "/TAI",
      title: "Coordinación TAI",
      icon: <NodeIndexOutlined />,
    },
    {
      path: "/PlanillasTAI",
      title: "Planillas TAI",
      icon: <FileTextOutlined />,
    },
    {
      path: "/TAIEstadisticas",
      title: "Estadísticas TAI",
      icon: <BarChartOutlined />,
    },
    {
      path: "/Fuec",
      title: "Lista FUEC",
      icon: <FileTextOutlined />,
    },
    {
      path: "/FuecConfig",
      title: "Configuración FUEC",
      icon: <SettingOutlined />,
    },
    {
      path: "/ObjetosContrato",
      title: "Objetos de Contrato",
      icon: <ProfileOutlined />,
    },
    {
      path: "/Configuraciones",
      title: "Configuraciones",
      icon: <SettingOutlined />,
    },
  ];

  const modulePath = `/${location.pathname.split("/")[2] || ""}`;
  const currentRoute = routeTitles.find((route) => route.path === modulePath);
  const currentTitle = currentRoute?.title || "Módulo Desconocido";

  const ChangePasswordModal = () => (
    <Modal
      title="Cambiar contraseña"
      open={changePasswordModalVisible}
      onCancel={handleModalClose}
      footer={null}
      destroyOnHidden
    >
      <Form layout="vertical" onFinish={handlePasswordChange}>
        <Form.Item
          label="Contraseña actual"
          name="currentPassword"
          rules={[{ required: true, message: "Ingrese su contraseña actual" }]}
        >
          <Input.Password />
        </Form.Item>
        <Form.Item
          label="Nueva contraseña"
          name="newPassword"
          rules={[
            { required: true, message: "Ingrese la nueva contraseña" },
            { min: 6, message: "Mínimo 6 caracteres" },
          ]}
        >
          <Input.Password />
        </Form.Item>
        <Form.Item
          label="Confirmar contraseña"
          name="confirmPassword"
          dependencies={["newPassword"]}
          rules={[
            { required: true, message: "Confirme la nueva contraseña" },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue("newPassword") === value) {
                  return Promise.resolve();
                }
                return Promise.reject("Las contraseñas no coinciden");
              },
            }),
          ]}
        >
          <Input.Password />
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit">
            Guardar cambios
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );

  // Definir el menú usando la prop `items`
  const menu = {
    items: [
      {
        key: "reglamento",
        icon: <FileTextOutlined />,
        label: "Reglamento Interno",
        onClick: () => window.open("https://reglamento-interno.mogotaxsas.com", "_blank"),
      },
      {
        type: "divider",
      },
      {
        key: "changePassword",
        label: "Cambiar contraseña",
        onClick: () => setChangePasswordModalVisible(true),
      },
      {
        key: "logout",
        label: "Cerrar sesión",
        onClick: handleLogout,
      },
    ],
  };

  return (
    <div
      className="header modern-header fade-in-tech"
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "0 20px",
        color: "white",
        position: "sticky",
        top: 0,
        zIndex: 1000,
        height: "50px",
      }}
    >
      {/* Botón para alternar el Sidebar */}
      <Button
        type="text"
        onClick={toggleSidebar}
        icon={<MenuOutlined style={{ color: "white", fontSize: "18px" }} />}
        className="tech-button"
        style={{ height: "35px" }}
      />

      {/* Título del módulo con ícono */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          flexGrow: 1,
          justifyContent: "center",
          height: "45px",
        }}
      >
        <div className="module-title">
          {currentRoute?.icon && (
            <span className="module-icon">
              {currentRoute.icon}
            </span>
          )}
          <h2
            style={{
              color: "white",
              fontSize: "20px",
              fontWeight: "600",
              textTransform: "uppercase",
              fontFamily: "'Roboto', sans-serif",
              margin: "0",
              padding: "0",
              lineHeight: "50px",
              textShadow: "0 0 10px rgba(22, 119, 255, 0.5)",
            }}
          >
            {currentTitle}
          </h2>
        </div>
      </div>

      {/* Controles de pantalla completa, configuración y estado de conexión */}
      <div style={{ display: "flex", alignItems: "center" }}>
        {/* Estado de conexión con nuevo componente */}
        <div style={{ marginRight: "15px" }}>
          <ConnectionStatus />
        </div>

        {/* Botón de Pantalla Completa */}
        <Tooltip
          title={
            isFullscreen ? "Salir de Pantalla Completa" : "Pantalla Completa"
          }
        >
          <Button
            type="text"
            onClick={handleFullscreen}
            className="tech-button"
            icon={
              isFullscreen ? (
                <FullscreenExitOutlined
                  style={{ color: "white", fontSize: "18px" }}
                />
              ) : (
                <FullscreenOutlined
                  style={{ color: "white", fontSize: "18px" }}
                />
              )
            }
            style={{ height: "35px", marginRight: "10px" }}
          />
        </Tooltip>

        {/* Dropdown de Configuración */}
        <Dropdown menu={menu}>
          <Button
            type="text"
            className="tech-button"
            icon={
              <SettingOutlined style={{ color: "white", fontSize: "18px" }} />
            }
            style={{ height: "35px", marginRight: "10px" }}
          />
        </Dropdown>

        {/* Avatar del Usuario */}
        <Avatar
          className="tech-badge"
          style={{
            marginLeft: "10px",
            backgroundColor: "#1677ff",
            width: "32px",
            height: "32px",
            fontSize: "14px",
            border: "2px solid rgba(22, 119, 255, 0.5)",
            boxShadow: "0 0 10px rgba(22, 119, 255, 0.3)",
          }}
          icon={<UserOutlined />}
        >
          {userInitial}
        </Avatar>

        {/* Nombre y cargo del usuario */}
        <div style={{ marginLeft: "10px", textAlign: "right", color: "white" }}>
          <div style={{ fontWeight: "600", fontSize: "14px", textShadow: "0 0 5px rgba(22, 119, 255, 0.3)" }}>
            {user?.nombre || "Usuario"}
          </div>
          <div style={{ fontSize: "12px", opacity: 0.9, color: "#00c896" }}>
            {user?.cargo || "Cargo no definido"}
          </div>
        </div>
      </div>
      {ChangePasswordModal()}
    </div>
  );
};

HeaderComponent.propTypes = {
  toggleSidebar: PropTypes.func.isRequired,
};

export default HeaderComponent;
